// export const apiUrl = 'https://businessexpoapiv1.greenkosovo.com/api/'; // production
export const apiUrl = 'https://businessexpoapi-stg.greenkosovo.com/api/';
// export const apiUrl = 'http://116.203.179.177:88/api/'; // development